<template>
	<div id="agentDetail">
		<DetailCard :config="config"></DetailCard>
		<div id="adteq" v-loading='loading' class='gcardfr'>

			<el-row :gutter="20" class=''>
				<el-col :span='16' v-if='!detail.parent && !$isNmAdminType()'>
					<el-button size='small' @click='importEq' type="primary" icon="">{{ $t('terminal.import_btn') }}</el-button>
					<el-button size='small' @click="batchImport" type='' plain>{{ $t('app_batch_import') }}</el-button>
					<el-button @click='batchDel' :disabled="sRows.length == 0" size='small' type='danger' plain>{{ $t('app_delete_select') }}
					</el-button>
				</el-col>
				<el-col :span='8'>
					<div class="glineflex">
						<label class="glinelb">{{ $t('terminal.search_device') }}：</label>
						<el-input @keyup.enter.native="getList" v-model='eqId' size='small' :placeholder="$t('terminal.device_SN_Name')">
						</el-input>
					</div>
				</el-col>
			</el-row>

			<el-table ref="multipleTable" class='gtbtop g-tb-pointer' tooltip-effect="dark" :data="tableData"
				@selection-change="batchSelected" style="width: 100%">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="deviceid" :label="$t('terminal.device_sn')" width="">
				</el-table-column>
				<el-table-column prop="devicename" :label="$t('terminal.device_name')" width="140">
				</el-table-column>
				<el-table-column prop="productName" :label="$t('terminal.device_model')">
				</el-table-column>
				<el-table-column prop="merchantName" :label="$t('merchant.store_name')">
				</el-table-column>
				<el-table-column prop="deviceStatus" :label="$t('terminal.binding_state')" width="">
				</el-table-column>
				<el-table-column prop="createtime" :label="$t('app_update_time')" width="176">
				</el-table-column>
				<el-table-column prop="name" :label="$t('app_operation')" width="120">
					<template slot-scope="scope">
						<span v-if='!detail.parent'>
							<el-button @click='moveRow(scope.row)' type='text'>{{ $t('app_move') }}</el-button>
							<label class='opbline'>|</label>
							<el-button @click='delRow(scope.row)' type='text' class='opdcolor'>{{ $t('app_delete') }}</el-button>
						</span>
					</template>
				</el-table-column>
			</el-table>

			<!-- <el-table
          ref="multipleTable"
          class='gtbtop'
          tooltip-effect="dark"
          :data="tableData"
          @selection-change="batchSelected"            
          style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="deviceid"
            label="设备SN"
            width="">
          </el-table-column>
          <el-table-column
            prop="devicename"
            label="设备名称"
            width="">
          </el-table-column>
          <el-table-column
            prop="productName"
            label="设备型号"
            width="">
          </el-table-column>
          <el-table-column                
            prop='terminalVersion'
            label="设备类型"
            width="">
          </el-table-column>
          <el-table-column
            prop="agentName"
            label="渠道商"
            width="">
          </el-table-column>
          <el-table-column
            prop="lineStatus"
            label="设备状态"
            width="">             
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="更新时间"
            width="170">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button @click='moveRow(scope.row)' type='text' >移动</el-button>
              <label class='opbline'>|</label>
              <el-button @click='delRow(scope.row)' type='text' class='opdcolor'>删除</el-button>
            </template>
          </el-table-column>
        </el-table> -->

			<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

			<EquipList :show='showdia' :config='econfig'></EquipList>
			<ImportEquip :config='iconfig'></ImportEquip>
		</div>

		<el-dialog class="gstdia" :title="$t('merchant.move_to_channel')" :visible.sync="showMove" @close='closeMv'>
			<el-form mmodel="tform">
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth">
					<Merchant :config='editMc'></Merchant>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeMv">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!moveVl" type="primary" @click="moveRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog @close="closeDia" style="min-width: 1140px;" class='gstdia' :title="$t('merchant.edit_channel')"
			:visible.sync="showEidtDia">
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item label="Client Key:" :label-width="$formlbWidth" prop='clientKey'>
					<el-input v-model="tform.clientKey" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.vendor_name')" :label-width="$formlbWidth" prop='agentName'>
					<el-input v-model="tform.agentName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.channel_contact')" :label-width="$formlbWidth" prop='agentPeople'>
					<el-input v-model="tform.agentPeople" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.contact_number')" :label-width="$formlbWidth" prop='phone'>
					<el-input v-model="tform.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='$isAdminType()' :label="$t('merchant.super_vendor')" :label-width="$formlbWidth" prop="parentId">
					<Merchant :config='sortMc'></Merchant>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="rqsbefore">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">
      </div> -->
		</el-dialog>
	</div>
</template>

<style>

</style>


<script>
	import DetailCard from '@/components/DetailCard.vue'
	import Pages from '@/components/Pages.vue'
	import EquipList from '@/components/EquipList.vue'
	import ImportEquip from '@/components/ImportEquip.vue'
	import Merchant from '@/components/Merchant.vue'
	export default {
		data() {
			return {
				sortMc: '',
				mobj: {},
				detail: '',
				moveVl: '',
				editMc: {},
				showMove: false,
				showdia: false,
				agId: '',
				econfig: {},
				iconfig: {},
				pconfig: '',
				config: '',
				loading: false,
				tableData: [],
				eqId: '',
				susr: '',
				bindSt: '',
				sRows: [],
				total: 0,
				page: 1,
				showEidtDia: false,
				tform: {
					agentID: '',
					clientKey: '',
					agentName: '',
					agentPeople: '',
					phone: '',
					parentId: ''
				},
				tformVal: {
					agentID: '',
					clientKey: '',
					agentName: '',
					agentPeople: '',
					phone: '',
					parentId: ''
				},
				rules: {
					agentID: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					clientKey: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					agentName: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					agentPeople: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					parentId: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}]
				},
			}
		},
		components: {
			DetailCard,
			Pages,
			EquipList,
			ImportEquip,
			Merchant
		},
		methods: {
			initMc(val) {
				var _this = this
				_this.sortMc = {
					vlkey: 'clientKey',
					size: 'small',
					value: val ? val : '',
					callback: (vl) => {
						_this.tform.parentId = vl ? vl : ''
						_this.tformVal.parentId = vl ? vl : ''
						_this.getDetail()
					}
				}
			},
			closeDia() {
				this.showEidtDia = false
				this.tform.agentID = ''
				this.tform.clientKey = ''
				this.tform.agentName = ''
				this.tform.agentPeople = ''
				this.tform.phone = ''
				this.tform.parentId = ''
			},
			rqsbefore() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			okDia() {

				this.$editAgent(this.tform.agentID, this.tform.clientKey, this.tform.agentName, this.tform.agentPeople,
					this.tform.phone, this.tform.parentId, res => {
						if (res.status == 200) {
							this.getDetail()
							this.closeDia()
							// this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}

					}, '')
			},
			setMcCtr(vl) {
				var _this = this
				this.editMc = {
					type: '0',
					size: '',
					vlkey: '',
					value: vl ? vl : '',
					callback: (vl) => {
						_this.moveVl = vl
					}
				}
			},
			batchImport() {
				var _this = this
				this.iconfig = {
					type: 1, //// 0.equipement 1.merchant
					agid: this.agId,
					showDia: true,
					callback: () => {
						_this.getList()
					}
				}
			},
			closeMv() {
				this.mobj = {}
				this.moveVl = ''
				this.showMove = false
			},
			moveRqs() {
				this.loading = true
				this.$moveEquip(this.moveVl, this.mobj.deviceid, res => {
					this.loading = false
					if (res.status == 200) {
						this.$message.success(res.message)
						this.getList()
						this.getDetail()
						this.closeMv()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			moveRow(row) {
				this.mobj = row
				this.showMove = true
				this.setMcCtr()
			},
			importEq(row) {
				var _this = this
				this.showdia = true
				this.econfig = {
					agid: this.agId, //this.tformVal.agentID
					title: this.$t('merchant.import_devices_vendors'),
					callback: ids => {
						///
						if (ids) {
							_this.$agentBindEq(_this.agId, ids, res => {
								_this.getList()
								_this.getDetail()
								_this.$message.success(res.message)
								_this.showdia = false
							}, () => {
								_this.$message.error(res.message)
							})
						} else {
							_this.showdia = false
						}
					}
				}
			},
			delRqs(did) {
				this.$agentUnbindEq(this.agId, did, res => {
					if (res.status == 200) {
						this.getList()
						this.getDetail()
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			delRow(row) {
				// console.log(row)  row.deviceid
				this.$showMsgBox(this.$t('app_delete_bind'), () => {
					this.delRqs(row.deviceid)
				})
			},
			batchDel() {
				this.$showMsgBox(this.$t('app_delete_bind_2'), () => {
					var ar = []
					this.sRows.forEach(item => {
						ar.push(item.deviceid)
					})
					this.delRqs(ar.toString())
				})
			},
			batchSelected(val) {
				this.sRows = val
			},
			getList() {
				this.$agentEquip(this.page, this.$gRow, this.agId, this.eqId, res => {
					if (res.status == 200) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			setCard(data) {
				var isTop = data.parent
				this.config = {
					rd1: [{
							tt: this.$t('merchant.vendor_id'),
							ct: data.agentId
						},
						{
							tt: this.$t('merchant.vendor_name'),
							ct: data.agentName
						},
						{
							tt: this.$t('merchant.super_vendor'),
							ct: data.parentName
						},
						{
							tt: this.$t('merchant.channel_contact'),
							ct: data.agentConnPeople
						}
					],
					rd2: [{
							tt: 'Client Key',
							ct: data.clientKey
						},
						{
							tt: this.$t('merchant.channel_add_time'),
							ct: data.createTime
						},
						{
							tt: this.$t('merchant.contact_number'),
							ct: data.agentPhonenumber
						}
					],
					rd3: [{
							tt: this.$t('merchant.binding_user'),
							ct: data.merchantNum
						},
						{
							tt:  this.$t('terminal.binding_device'),
							ct: data.deviceNum
						}
					],
					edit: !isTop ? () => {
						this.showEidtDia = true
						this.tform = this.tformVal
						this.setformVl()
					} : ''
				}
			},
			setformVl() {
				var data = this.detail
				this.tformVal.agentID = data.agentId;
				this.tformVal.agentName = data.agentName;
				this.tformVal.clientKey = data.clientKey;
				this.tformVal.agentPeople = data.agentConnPeople;
				this.tformVal.phone = data.agentPhonenumber;
				this.tformVal.parentId = data.parentId;
				this.initMc(data.parentId)
			},
			getDetail() {
				this.$agentDetail(this.agId, res => {
					this.setCard(res.data)
					this.detail = res.data
				}, '')
			}
		},
		mounted() {
			this.agId = this.$route.query.id
			this.getDetail()
			this.getList()
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}


		}
	}
</script>
